// extracted by mini-css-extract-plugin
export var chip = "_a6-0";
export var filterDropdown = "_a6-5";
export var filterItem = "_a6-6";
export var icon = "_a6-1";
export var removeButton = "_a6-3";
export var removeIcon = "_a6-4";
export var separator = "_a6-2";